/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import { useTranslation } from "react-i18next";
import { Navigation } from "@/components/customCopmonent/landingSection/navigation";
import { FooterSection } from "@/components/customCopmonent/landingSection/footer-section";
import {
	PageShell,
	SectionDivider,
	SectionWrapper,
} from "./ManagementTeam.page-primitives";
import DotGrid from "@/components/customCopmonent/DotGrid";
import { PageHeaderHero, PAGE_HERO_CLASS } from "@/components/customCopmonent/Text/PageHeaderHero";
import TeamCard from "./TeamCard";
import Seo from "@/components/Seo";

const ManagementTeam = () => {
	const { t } = useTranslation();

	const pageData = {
		title: t("aboutPages.managementTeam.hero.title"),
		bgimage: "/images/headerPhotos/banner-priory-management-team.jpg",

		description: t("aboutPages.managementTeam.hero.tagline"),
		meta: [
			t("aboutPages.managementTeam.hero.meta.leadership"),
			t("aboutPages.managementTeam.hero.meta.engineeringExcellence"),
			t("aboutPages.managementTeam.hero.meta.globalExecution"),
		],

		team: [
			{
				name: "Venkatesh Kulkarni",
				image: "/images/ManagementPhoto/ve.jpeg",
				role: t("aboutPages.managementTeam.members.venkateshKulkarni.role"),
				bio: t("aboutPages.managementTeam.members.venkateshKulkarni.bio"),
				accent: t("aboutPages.managementTeam.members.venkateshKulkarni.accent"),
			},
			{
				name: "Shridhar Uppin",
				image: "/images/ManagementPhoto/sk.jpeg",
				role: t("aboutPages.managementTeam.members.shridharUppin.role"),
				bio: t("aboutPages.managementTeam.members.shridharUppin.bio"),
				accent: t("aboutPages.managementTeam.members.shridharUppin.accent"),
			},
			{
				name: "Mukund Yeshwant Vaidya",
				image: "/images/ManagementPhoto/Mukun.jpeg",
				role: t("aboutPages.managementTeam.members.mukundVaidya.role"),
				bio: t("aboutPages.managementTeam.members.mukundVaidya.bio"),
				accent: t("aboutPages.managementTeam.members.mukundVaidya.accent"),
			},
			{
				name: "Dipak Deshpande",
				image: "/images/ManagementPhoto/dipakdeshpand.jpeg",
				role: t("aboutPages.managementTeam.members.dipakDeshpande.role"),
				bio: t("aboutPages.managementTeam.members.dipakDeshpande.bio"),
				accent: t("aboutPages.managementTeam.members.dipakDeshpande.accent"),
			},
			{
				name: "Vinay",
				image: "/images/ManagementPhoto/Vina.jpg",
				role: t("aboutPages.managementTeam.members.vinay.role"),
				bio: t("aboutPages.managementTeam.members.vinay.bio"),
				accent: t("aboutPages.managementTeam.members.vinay.accent"),
			},
		],
	};

	return (
		<PageShell>
			<Seo
				titleKey="aboutPages.managementTeam.seo.title"
				descriptionKey="aboutPages.managementTeam.seo.description"
				path="/management-team"
			/>
			<Navigation />
			{/* HEADER */}{" "}
			<SectionWrapper className={PAGE_HERO_CLASS}>
				<div className="absolute inset-0 ">
					{" "}
					<div
						className="absolute bottom-3 inset-0 opacity-35 scale-105"
						style={{
							backgroundImage: `url(${pageData.bgimage})`,
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					/>
					<DotGrid
						dotSize={4}
						gap={15}
						baseColor="#3b0092"
						activeColor="#f09a38"
						proximity={100}
						shockRadius={200}
						shockStrength={3}
						resistance={750}
						returnDuration={1.5}
					/>
				</div>
				<PageHeaderHero
					// align="center"
					title={pageData.title}
					description={pageData.description}
					meta={pageData.meta}
				/>
			</SectionWrapper>
			<SectionDivider />
			{/* VALUES */}
			<SectionDivider />
			{/* TEAM */}
			<SectionWrapper className="pt-0">
				<div className="flex flex-wrap justify-center gap-6 sm:gap-10">
					{pageData.team.map((member: any, index: number) => (
						<TeamCard
							key={index}
							member={member}
						/>
					))}
				</div>
			</SectionWrapper>
			<FooterSection />
		</PageShell>
	);
};

export default ManagementTeam;
